const peak = {
  primary: '#004a38',
  secondary: '#f7f0de',
  background: '#f2e8d9',
};

export default peak;
